import { _getModelClass, _getModelName, _getStoreFromRecord, buildOperationUrl } from './build-url';
import { strictifyHttpVerb } from './types';
export default function instanceOp(options) {
  return function runInstanceOp(payload) {
    const recordClass = _getModelClass(this);
    const modelName = _getModelName(recordClass);
    const store = _getStoreFromRecord(this);
    const {
      ajaxOptions,
      path,
      before,
      after,
      type = 'put',
      urlType = 'updateRecord'
    } = options;
    const requestType = strictifyHttpVerb(type);
    const adapter = store.adapterFor(modelName);
    const fullUrl = buildOperationUrl(this, path, urlType);
    const data = before && before.call(this, payload) || payload;
    return adapter.ajax(fullUrl, requestType, Object.assign(ajaxOptions || {}, {
      data
    })).then(response => {
      if (after && !this.isDestroyed) {
        return after.call(this, response);
      }
      return response;
    });
  };
}